/**
 * Brand class constants, deliberately OUTSIDE any `'use client'` module.
 *
 * These used to live in `free-tool-transcribe-cta.tsx`, which is a client module
 * because it uses hooks. A Server Component importing a value from a client
 * module receives a client reference rather than the value, so the constant
 * arrives `undefined` and the class simply vanishes from the rendered markup.
 *
 * It survived there for a while only by accident: while `GRADIENT_CTA_CLASS` was
 * a single string literal the bundler could inline it. The moment it was rewritten
 * as a template literal composed from another binding, inlining stopped and every
 * free-tool primary CTA silently rendered as `class="w-full border border-transparent"`
 * with no gradient at all. Same failure mode as the FAQ arrays that shipped
 * without their `FAQPage` markup.
 *
 * Keep class constants here. Nothing in this file may import from a client module.
 */

/**
 * The three brand stops on their own, for surfaces that need the gradient at a
 * size other than the full CTA (eyebrow pills, compact nav buttons).
 *
 * The literal appears ~119 times across ~60 files; compose this instead of
 * retyping the hexes.
 */
export const BRAND_GRADIENT = 'bg-gradient-to-r from-[#8B5CF6] via-[#EC4899] to-[#F59E0B]';

/** The house primary-CTA treatment. */
export const GRADIENT_CTA_CLASS = `inline-flex items-center justify-center rounded-full ${BRAND_GRADIENT} px-8 py-4 text-center text-base font-semibold text-white shadow-[0_0_28px_rgba(236,72,153,0.45)] transition-opacity hover:opacity-95`;
